import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetSchoolActivityQuery } from '../../store/api/schoolAdminApi'
import { KpiCard } from '../../components/school/SchoolUi'

const SchoolActivityDetail: React.FC = () => {
  const { t } = useTranslation('school')
  const { ticketId } = useParams()
  const { data, isLoading } = useGetSchoolActivityQuery({ ticketId: Number(ticketId) })

  if (isLoading) return <div className="text-gray-500">{t('common.loading')}</div>
  if (!data) return <div className="text-gray-500">{t('units.empty')}</div>

  const a = data.activity
  const p = data.participation
  const ai = data.aiUsage
  const q = data.interactionQuality

  return (
    <div className="space-y-6">
      <div>
        <Link to={`/pending/units/${a.unitId}`} className="text-sm text-blue-600 hover:underline">{t('activities.back')}</Link>
        <h1 className="text-2xl font-bold text-gray-900 mt-2">{a.name}</h1>
        <p className="text-gray-600">{a.className} · {a.unitName} · {a.teacherName || t('common.na')}</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold mb-3">{t('activities.participation')}</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <KpiCard label={t('activities.assigned')} value={p.assigned} />
          <KpiCard label={t('activities.participated')} value={p.participated} />
          <KpiCard label={t('activities.completed')} value={p.completed} />
          <KpiCard label={t('activities.notParticipated')} value={p.notParticipated} />
        </div>
      </div>

      <div>
        <h2 className="text-lg font-semibold mb-3">{t('activities.aiUsage')}</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          <KpiCard label={t('activities.sessions')} value={ai.sessions} />
          <KpiCard label={t('activities.interactions')} value={ai.interactions} />
          <KpiCard label={t('activities.avgInteractions')} value={ai.avgInteractions} />
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-5">
        <h2 className="text-lg font-semibold mb-3">{t('activities.interactionQuality')}</h2>
        {q?.available ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <KpiCard label={t('activities.followUps')} value={q.followUpQuestions} />
            <KpiCard label={t('activities.sources')} value={q.sourcesRequested ? t('activities.yes') : t('activities.no')} />
            <KpiCard label={t('activities.reformulated')} value={q.reformulated ? t('activities.yes') : t('activities.no')} />
            <KpiCard label={t('activities.reflections')} value={q.reflectionCompleted ? t('activities.yes') : t('activities.no')} />
          </div>
        ) : (
          <p className="text-sm text-gray-500">{t('overview.comingSoon')}</p>
        )}
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-5">
        <h2 className="text-lg font-semibold mb-2">{t('activities.difficultConcepts')}</h2>
        <p className="text-sm text-gray-500">{t('activities.difficultConceptsSoon')}</p>
      </div>
    </div>
  )
}

export default SchoolActivityDetail
